import { StyledLayout } from '../../globalStyledComponents/Layout'
import Footer from '../../components/Footer'
import { Result } from 'antd'
import SusiPortraitImg from '../../assets/img/susi_portrait.png'

const { Content } = StyledLayout

const Monitor = () => {
  return (
    <StyledLayout className="layout">
      <Content>
        <h1 style={{ margin: '50px 0' }}>Monitor</h1>
        <Result
          status="warning"
          title="Work in progress."
          extra={<img src={SusiPortraitImg} alt="Susi Portrait" />}
        />
      </Content>
      <Footer />
    </StyledLayout>
  )
}

export default Monitor
